import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, BookOpenIcon, LeafIcon, HeartIcon, SparklesIcon, UsersIcon, ClockIcon, Droplets, Leaf } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'Manual de Fermentos Naturales',
    description: 'Domina el arte de la masa madre, kéfir, kombucha y chucrut para transformar tu salud digestiva.',
    image: 'https://cdn.magicpatterns.com/uploads/hUg23cpR1971aXTEuDWbrB/7.webp',
    icon: <Droplets className="w-6 h-6" data-id="element-310" />,
    checks: ['Masa madre paso a paso', 'Kéfir de agua y leche', 'Kombucha casera', 'Chucrut y vegetales fermentados'],
    badge: 'Salud Digestiva'
  }, {
    title: 'Cocina de Estación y Nutrición',
    description: 'Aprende a elegir y preparar los alimentos según los ciclos de la naturaleza para máxima vitalidad.',
    image: 'https://cdn.magicpatterns.com/uploads/5e1v4YwhdvxrtFb8TDzevb/6.webp',
    icon: <Leaf className="w-6 h-6" data-id="element-311" />,
    checks: ['Recetas por estación', 'Caldos reconstituyentes', 'Combinaciones nutritivas', 'Conservación natural'],
    badge: 'Energía Vital'
  }, {
    title: 'Botiquín Herbal Ancestral',
    description: 'Descubre las plantas ancestrales que pueden ayudarte a sanar tu cuerpo y prevenir enfermedades.',
    image: 'https://cdn.magicpatterns.com/uploads/cvY7UnwjtxvWj6iDeuq8Cy/8.webp',
    icon: <Leaf className="w-6 h-6" data-id="element-312" />,
    checks: ['Tinturas y extractos', 'Infusiones medicinales', 'Ungüentos caseros', 'Hierbas para cada dolencia'],
    badge: 'Medicina Natural'
  }];
  return <section id="what-you-get" className="py-24 bg-transparent relative overflow-hidden pt-[9px] pb-[9px]" data-id="element-313">
      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-314">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-black text-center mb-20 tracking-tight uppercase text-[#191717]" data-id="element-315">
          LO QUE TE LLEVÁS CON EL <br data-id="element-316" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#8b7355] to-[#3e2723] bg-[#E8DEDE]" data-id="element-317">
            RECETARIO ANCESTRAL
          </span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[25px]" data-id="element-318">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-[2.5rem] overflow-hidden border border-[#0f1711]/10 flex flex-col h-full group hover:border-[#8b7355]/30 transition-all duration-500 shadow-sm" data-id="element-319">
              <div className="relative mb-8 rounded-2xl overflow-hidden border border-[#0f1711]/5 aspect-[3/2]" data-id="element-320">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" loading="lazy" data-id="element-321" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f1711]/10 via-transparent to-transparent opacity-40" data-id="element-322" />
              </div>

              <div className="p-10 flex flex-col flex-grow pt-[0px] pb-[0px] pl-[20px] pr-[20px] gap-[0px]" data-id="element-323">
                <div className="flex items-center gap-3 mb-6" data-id="element-324">
                  {item.icon}
                  <h3 className="text-2xl font-black tracking-wide uppercase text-[#1F1D1D]" data-id="element-325">
                    {item.title}
                  </h3>
                </div>

                <p className="mb-8 font-medium italic text-[#6F7884]" data-id="element-326">
                  {item.description}
                </p>

                <ul className="space-y-5 mb-10 flex-grow" data-id="element-327">
                  {item.checks.map((check, j) => <li key={j} className="flex items-start gap-4" data-id="element-328">
                      <div className="mt-1 bg-[#8b7355]/10 rounded-full p-1 shadow-sm" data-id="element-329">
                        <CheckIcon className="w-4 h-4 text-[#8b7355]" data-id="element-330" />
                      </div>
                      <span className="text-lg font-bold leading-tight text-[#7F8792]" data-id="element-331">
                        {check}
                      </span>
                    </li>)}
                </ul>

                <div className="mt-auto" data-id="element-332">
                  <div className="inline-block px-8 py-2.5 rounded-full bg-[#8b7355]/10 border border-[#8b7355]/20 text-xs font-black tracking-[0.2em] uppercase text-[#1E0308]" data-id="element-333">
                    {item.badge}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}